import { createStore, applyMiddleware, combineReducers } from 'redux';
import { thunk } from 'redux-thunk';
import authReducer from './reducers/authReducer';
import userReducer from './reducers/userReducer';
import packageReducer from './reducers/packageReducer';
import deliveryReducer from './reducers/deliveryReducer';
import transactionReducer from './reducers/transactionReducer';
import reviewReducer from './reducers/reviewReducer';
import faqReducer from './reducers/faqReducer';
import helpTopicReducer from './reducers/helpTopicReducer';
import chatReducer from './reducers/chatReducer';
import notificationReducer from './reducers/notificationReducer';
import analyticsReducer from './reducers/analyticsReducer';
import commissionReducer from './reducers/driverCommissionReducer';
import termsAndPoliciesReducer from './reducers/termsAndpoliciesReducer';
import contactSupportReducer from './reducers/contactSupportReeducer';
import vehicleReducer from './reducers/vehicleReducer';
import businessReducer from './reducers/businessReducer';
import driverReducer from './reducers/driverReducer';
import privacySettingsReducer from './reducers/privacySettingsReducer';
import bankDetailsReducer from './reducers/bankDetailsReducer';
import packagePlanReducer from './reducers/planReducer';
import rateReducer from './reducers/rateReducer';
import paymentProofReducer from './reducers/paymentProofReducer';
import companySettingsReducer from './reducers/companySettingsReducer';
import packageEvidenceReducer from './reducers/packageEvidenceReducer';
import protectionTierReducer from './reducers/protectionTierReducer';
import claimReducer from './reducers/claimReducer';
import appVersionReducer from './reducers/appVersionReducer';
import statusHistoryReducer from './reducers/statusHistoryReducer';
import resourceReducer from './reducers/resourceReducer';
import loyaltyConfigReducer from './reducers/loyaltyConfigReducer';
import cashoutReducer from './reducers/cashoutReducer';
import referralReducer from './reducers/referralReducer';
import merchantReducer from './reducers/merchantReducer';
import productReducer from './reducers/productReducer';
import productListingReducer from './reducers/productListingReducer';
import contactLogReducer from './reducers/contactLogReducer';
import orderReducer from './reducers/orderReducer';
import packagePriceReducer from './reducers/packagePriceReducer';
import protectionReducer from './reducers/protectionReducer';
import reportReducer from './reducers/reportReducer';
import partnerReducer from './reducers/partnerReducer';
import partnerSubscriptionReducer from './reducers/partnerSubscriptionReducer';
import partnerPlanReducer from './reducers/partnerPlanReducer';
import driverPartnerReducer from './reducers/driverPartnerReducer';
import referredDriverReducer from './reducers/referredDriverReducer';
import commissionRuleReducer from './reducers/commissionRuleReducer';
import referralMilestoneReducer from './reducers/referralMilestoneReducer';
import pendingCommissionReducer from './reducers/pendingCommissionReducer';
import driverPartnerPayoutReducer from './reducers/driverPartnerPayoutReducer';

// Combine reducers if there are multiple reducers
const rootReducer = combineReducers({
  auth: authReducer,
  users: userReducer,
  packages: packageReducer,
  deliveries: deliveryReducer,
  transactions: transactionReducer,
  reviews: reviewReducer,
  faqs: faqReducer,
  helpTopics: helpTopicReducer,
  chat: chatReducer,
  notifications: notificationReducer,
  analytics: analyticsReducer,
  commissions: commissionReducer,
  terms: termsAndPoliciesReducer,
  supportMessages: contactSupportReducer,
  vehicles: vehicleReducer,
  businesses: businessReducer,
  drivers: driverReducer,
  privacySettings: privacySettingsReducer,
  bank: bankDetailsReducer,
  plans: packagePlanReducer,
  rates: rateReducer,
  proofs: paymentProofReducer,
  companySettings: companySettingsReducer,
  packageEvidence: packageEvidenceReducer,
  protectionTiers: protectionTierReducer,
  claims: claimReducer,
  appVersions: appVersionReducer,
  statusHistory: statusHistoryReducer,
  resources: resourceReducer,
  loyaltyConfig: loyaltyConfigReducer,
  cashOuts: cashoutReducer,
  referralUsers: referralReducer,
  merchants: merchantReducer,
  products: productReducer,
  productListings: productListingReducer,
  contactLogs: contactLogReducer,
  merchantOrders: orderReducer,
  packagePrice: packagePriceReducer,
  protectionQuote: protectionReducer,
  reports: reportReducer,
  partners: partnerReducer,
  partnerSubscriptions: partnerSubscriptionReducer,
  partnerPlans: partnerPlanReducer,
  driverPartners: driverPartnerReducer,
  referredDrivers: referredDriverReducer,
  commissionRules: commissionRuleReducer,
  referralMilestones: referralMilestoneReducer,
  pendingCommissions:pendingCommissionReducer,
  driverPartnerPayouts:driverPartnerPayoutReducer,
});


// Create Redux store with middleware
const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
